import { render, staticRenderFns } from "./user-diamond.vue?vue&type=template&id=d33a04fe&scoped=true&"
import script from "./user-diamond.vue?vue&type=script&lang=js&"
export * from "./user-diamond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33a04fe",
  null
  
)

export default component.exports